import Vue from "vue";
import Vuex from "vuex";
import axios from "@/axios";
import VueCookies from "vue-cookies";
import { AuthStore } from "@/modules/auth/store";
import { FieldsAminStore } from "@/modules/fields-admin/store";
import { PackageStore } from "@/modules/packages/store"
import { CaseStore } from "@/modules/case/store";
import { ProfileStore } from "@/modules/profile/store";
import ThemeStore from "@/modules/theme/store";
import { DashboardStore } from "@/modules/dashboard/store"
import { FormsAdminStore } from "@/modules/form-admin/store"
import { ChecksAdminStore } from "@/modules/checks/store"
import { BlocksAdminStore } from "@/modules/blocks-admin/store"
import { LightRayStore } from "../../../shared/light-ray/store"
import { Research } from "@shared/tools/store/research.js";
import { VLexStore } from "@shared/tools/store/vLex.js";
import { NLPAnalysis } from "@shared/tools/store/nlp-analysis.js";
import { WorkFlowStore } from "../../../shared/workflow/store"
import { riskAssessment } from "../pages/risk-assessment/store"
import { Store } from "../../../shared/store";
import { LoginStore } from "@/pages/login/store";
import { CaseCreationStore } from "@shared/case-creation/store";
import { CaseEntitiesStore } from "@shared/case-entities/store";
import { appList } from "@shared/components/form-builder/utils";
import { LangStore } from "@shared/plugins/i18n/store";
import { LocalizationStore } from "@shared/modules/localization/store";

import { FormsPreview } from "@shared/forms-preview/store";
import { AdditionalFormsStore } from "@shared/additional-forms/store";
import { WAMStore } from "@shared/modules/work-allocation-matrix-admin/store";
import { VersionsStore } from "@shared/modules/versions/store";
import {getSocketUrl} from "@shared/utils/functions"
import { fetchFooterFields } from "../pages/theme-admin/services";

Vue.use(Vuex);
export const RootStore = {
  state: {
    currentApp: appList.TENANT,
    isClient: false,
    isTenant: false,
    tenant_id: null,
    tenant_name: null,
    isNavCollapsed: window.localStorage.getItem("nav_collapsed"),
    isEmailNavCollapsed: window.localStorage.getItem("emailnav_collapsed"),
    form_rows: [],
    userPermissions: [],
    isPermission: false,
    user_details: null,
    clientData: null,
    entityTypeList: [],
    userFeatures: [],
    systemFields: {},
    autoPopulatedCountryList: [],
    userType:'',
    client_id: null,
    footerText: "",
    use_footer: false,
    notificationCounter: 0,
    footerFields: [],
  },
  getters: {
    getTenantId: (state) => state.tenant_id,
    getTenantName: (state) => state.tenant_name,
    getNavCollapsed: (state) => state.isNavCollapsed,
    getEmailNavCollapsed: (state) => state.isEmailNavCollapsed,
    getFormRows: (state) => state.form_rows,
    getUserPermissions: (state) => state.userPermissions.map(el => el.code),
    getIsPermission: (state) => state.isPermission,
    getUserDetails: (state) => state.user_details,
    getClientData: (state) => state.clientData,
    getIsTenant: (state) => state.isTenant,
    getIsClient: (state) => state.isClient,
    getClientLogo: (state) => state.clientData?.deatils?.logo_url,
    getClientFavicon: (state) => state.clientData?.deatils?.favicon_url,
    getUserFeatures: (state) => state.userFeatures,
    getSystemFields: (state) => state.systemFields,
    getAutoPopulatedCountryList: (state) => state.autoPopulatedCountryList,
    getCurrentApp: (state) => state.currentApp,
    getUserType: (state) => state.userType,
    getClientId: (state) => state.client_id,
    getFooterText: (state) => state.footerText,
    getUseFooter: (state) => state.use_footer,
    getFooterFields: (state) => state.footerFields,
    getNotificationCounter: state => state.notificationCounter,
  },
  mutations: {
    SET_NAV_COLLAPSE(state, payload) {
      state.isNavCollapsed = payload;
    },
    SET_EMAIL_NAV_COLLAPSE(state, payload) {
      state.isEmailNavCollapsed = payload;
    },
    SET_TENANT_ID(state, payload) {
      state.tenant_id = payload;
    },
    SET_TENANT_NAME(state, payload) {
      state.tenant_name = payload;
    },
    SET_CLIENT_ID(state, payload) {
      state.client_id = payload;
    },
    SET_USER(state, payload) {
      state.user_details = payload
    },
    SET_CLIENT(state, payload) {
      state.clientData = payload
    },
    SET_FORM_ROWS(state, payload) {
      state.form_rows = payload;
    },
    SET_USER_PERMISSIONS(state, payload) {
      state.userPermissions = payload;
    },
    CHECK_PERMISSION_UPDATED(state, value) {
      state.isPermission = value
    },
    SET_TENANT_TRUE(state) {
      state.isTenant = true;
      state.isClient = false;
    },
    SET_CLIENT_TRUE(state) {
      state.isClient = true;
      state.isTenant = false;
    },
    SET_ENTITY_TYPE_LIST(state, payload) {
      state.entityTypeList = payload;
    },
    SET_USER_FEATURES(state, payload) {
      state.userFeatures = payload
    },
    SET_SYSTEM_FIELDS(state, payload) {
      state.systemFields = payload;
    },
    SET_AUTO_POPULATED_COUNTRY_LIST(state, payload) {
      state.autoPopulatedCountryList = payload;
    },
    SET_USER_TYPE(state, payload){
      state.userType = payload
    },
    SET_FOOTER_TEXT(state, payload){
      state.footerText = payload
    },
    SET_USE_FOOTER(state, payload){
      state.use_footer = payload
    },
    SET_FOOTER_FIELDS(state, payload){
      state.footerFields = payload
    },
    SET_NOTIFICATION_COUNTER(state, payload) {
        state.notificationCounter = payload;
    }
  },
  actions: {
    setUser({commit} , payload) {
      commit("SET_USER", payload)
    },
    setNavCollapsed({ commit }, payload) {
      window.localStorage.setItem("nav_collapsed", payload);
      commit("SET_NAV_COLLAPSE", payload);
    },
    setEmailNavCollapsed({ commit }, payload) {
      window.localStorage.setItem("emailnav_collapsed", payload);
      commit("SET_EMAIL_NAV_COLLAPSE", payload);
    },
    setTenantId({ commit }, payload) {
      commit("SET_TENANT_ID", payload);
    },
    setSystemFields({commit}, payload) {
      commit("SET_SYSTEM_FIELDS", payload);
    },
    setFooterText({commit}, payload) {
      commit("SET_FOOTER_TEXT", payload);
    },
    setUseFooter({commit}, payload) {
      commit("SET_USE_FOOTER", payload);
    },
     setFooterFields({commit}, payload) {
      commit("SET_FOOTER_FIELDS", payload);
    },
    createSocketNotificationCount({dispatch, commit}, userId) {
        let url = getSocketUrl()
        const wsUrl = `${url}/user-notifications/ws/${userId}/count`
        const socket = new WebSocket(wsUrl)
        socket.onopen = (event) => {
          console.log(event)
          console.log("websocket notifications opened")
        }

        socket.onerror = (event) => {
          console.log("error in websocket notifications")
          console.log(event)
        }

        socket.onclose = (event) => {
          console.log(event)
          dispatch("createSocketNotificationCount", userId)
        }

        socket.onmessage = (event)=> {
            event = JSON.parse(event.data)
            console.log('event?.data: ', event)
            if (event?.count || event?.count == 0) {
              commit('SET_NOTIFICATION_COUNTER', event.count)
            }
        }
    },
    async fetchTenantId({ commit, dispatch }) {
      try {
        // const { data } = await axios.post(`user-auth/init`, {});
        const { data } = await axios.post(`global-auth/init`, {});
        if (data) {
          // VueCookies.set("isClient",true)
          // console.log("runninng in tenant init")
          if (data.client_id && data.client_details) {
            commit("SET_CLIENT_TRUE")
            VueCookies.set("isClient",true)
            commit("SET_CLIENT", {
              id: data.client_id,
              deatils: data.client_details,
            })
          } else {
            commit("SET_TENANT_TRUE")
            VueCookies.set("isClient",false)
          }
          commit("SET_TENANT_ID", data?.tenant_id);
          commit("SET_TENANT_NAME", data?.tenant_details?.title);
          commit("SET_USER", data.user_details)
          commit("SET_USER_TYPE", data?.user_type)
          commit("SET_CLIENT_ID", data?.client_id)
          dispatch("createSocketNotificationCount", data.user_details.id)
        }
      } catch (error) {
        console.log(error.message || `ERROR FETCHING TENANT ID`);
      }
    },
    async fetchClientUpdatedDetails({ commit }) {
      const { data } = await axios.post(`global-auth/init`, {});
      if (data && data.client_id && data.client_details) {
            commit("SET_CLIENT", {
              id: data.client_id,
              deatils: data.client_details,
            })
      } 
    },
    async fetchFormRows({commit}, payload) {
      try {
          const { data } = await axios.get("/tenant-form", payload);
          // this.rows = data?.data ?? [];
          if (data) {
            commit("SET_FORM_ROWS", data?.data || []);
          }
      } catch (error) {
          console.log("[+] error while fetching tenant-form  :>> ", error);
      }
    },

  
    async fetchPermissions({commit}) {
      try {
        const { data } = await axios(`user/permissions`) 
        if (data) {
          commit("SET_USER_PERMISSIONS", data || [])
          commit("CHECK_PERMISSION_UPDATED", true)
        }
      } catch (error) {
        console.log('error :>> ', error);
      }
    },
  
    async fetchEntityTypeList({commit}) {
      try {
        const { data } = await axios.get(`entity`) 
        if (data) {
          commit("SET_ENTITY_TYPE_LIST", data || [])
        }
      } catch (error) {
        console.log('error :>> ', error);
      }
    },

    async getAllFeaturesList({commit}) {
      try {
          let { data } = await axios.get(`license-pack/user/assigned-features`);
          data.push("gdc__person")
          commit("SET_USER_FEATURES", data)

      } catch (error) {
          console.log(error, "errror");
      }
    },

    async getAllCountryListForAutoPopulated({commit}) {
      try {
        let url = `/data/dropdown/country`;
        const response = await axios.get(url);
        commit("SET_AUTO_POPULATED_COUNTRY_LIST", response?.data);
      } catch (err) {
        console.log("err", err);
      }
    },

    async fetchFooterDetails({ getters, dispatch }) {
      try {
        let userType, id;
        if (getters.getIsClient) {
          userType = 'client';
          id = getters.getClientId;
        } else {
          userType = 'tenant';
          id = getters.getTenantId;
        }
        let { data } = await fetchFooterFields(userType, id);
        let fields = data?.fields?.length ? data?.fields : null;
        let privacyPolicyText = data?.text_content || '';
        let usePrivacyPolicy = data?.use_footer;

        if (getters.getIsClient && !usePrivacyPolicy) {
          const resp = await fetchFooterFields("tenant", getters.getTenantId);
          data = resp?.data;
          fields = data?.fields?.length ? data?.fields : null;
          privacyPolicyText = data?.text_content || '';
          usePrivacyPolicy = data?.use_footer;
        }
        dispatch("setFooterFields", fields);
        dispatch("setFooterText", privacyPolicyText);
        dispatch("setUseFooter", usePrivacyPolicy);
      } catch(err) {
        console.log("err", err);
      }

    },

  },
  modules: {
    auth: {
      ...AuthStore,
    },
    fieldsAdmin: { ...FieldsAminStore },
    CaseStore: { ...CaseStore },
    PackageStore: {...PackageStore},
    formsAdmin: {...FormsAdminStore},
    checksAdmin: {...ChecksAdminStore},
    blocksAdmin: {...BlocksAdminStore},
    ProfileStore: {...ProfileStore},
    DashboardStore: {...DashboardStore},
    ThemeStore: {...ThemeStore},
    LightRayStore: {...LightRayStore},
    WorkFlowStore: {...WorkFlowStore},
    riskAssessment: {...riskAssessment},
    Research: {...Research},
    VLexStore: { ...VLexStore },
    NLPAnalysis: {...NLPAnalysis},
    Store: {...Store},
    LoginStore: {...LoginStore},
    CaseCreationStore: { ...CaseCreationStore },
    CaseEntitiesStore: { ...CaseEntitiesStore },
    LangStore: { ...LangStore },
    LocalizationStore: { ...LocalizationStore },
    FormsPreview: {...FormsPreview },
    AdditionalFormsStore: {...AdditionalFormsStore },
    WAMStore: { ...WAMStore },
    VersionsStore: { ...VersionsStore }
  },
};

const store = new Vuex.Store(RootStore);

export default store;
